export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20warm%20composition%20with%20deep%20crimson%20and%20dark%20tones%2C%20geometric%20shapes%20intersecting%20like%20breaking%20news%20fragments%2C%20editorial%20artistic%20style%20with%20soft%20gradients%2C%20energy%20and%20motion%20in%20abstract%20forms%2C%20no%20text%20no%20people%2C%20cinematic%20atmosphere&width=1800&height=900&seq=hero-bg-51-001&orientation=landscape"
          alt="吃瓜网51背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-300 text-xs md:text-sm font-medium mb-5 whitespace-nowrap">
              🔥 全网黑料聚集地
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-white mb-3 leading-tight">
              吃瓜网51 - 全网最新爆料黑料专区
            </h1>

            <p className="text-base md:text-lg text-white/80 mb-6 font-medium">
              每日深扒娱乐圈内幕，不放过任何一个瓜
            </p>

            <p className="text-sm md:text-base text-white/65 leading-relaxed mb-8 max-w-xl lg:max-w-none">
              吃瓜网51是国内领先的娱乐黑料聚合平台，聚焦明星八卦、网红爆料、综艺内幕与热点事件深度追踪。我们每日更新最新黑料，用第一手信息带你走进娱乐圈的真实世界。无论是最新绯闻、翻车实锤还是行业潜规则，这里都有你想看的料。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">200+</div>
                <div className="text-xs text-white/55 mt-1">日均更新爆料</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden md:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">30+</div>
                <div className="text-xs text-white/55 mt-1">覆盖话题领域</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden md:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">千万级</div>
                <div className="text-xs text-white/55 mt-1">吃瓜群众聚集</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line"></i>
                投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-md aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20art%20composition%20with%20warm%20crimson%20red%20and%20dark%20tones%2C%20fragmented%20newspaper%20aesthetic%2C%20geometric%20shapes%20like%20social%20media%20buzz%2C%20dramatic%20lighting%2C%20modern%20minimalist%20style%2C%20no%20text%20no%20people%2C%20cinematic%20editorial%20look&width=800&height=1000&seq=hero-main-51-002&orientation=portrait"
                alt="吃瓜网51爆料黑料主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}